import React, { useContext } from "react";
import { Outlet,Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTachometerAlt,faSignOut,faUser} from '@fortawesome/free-solid-svg-icons';
import { CustomerContext } from "./CustomerContext";

export default function CustomerAccount(){
    const {customerData}=useContext(CustomerContext)
    
    return (
        <div className=" max-w-full min-w-fit">
           <div className="flex flex-row  min-w-fit gap-x-4 mb-4 max-w-32">
            <Link to="change" className=" flex flex-row max-w-full min-w-fit gap-x-4 mb-4 hover:text-blue-500 ">
              <FontAwesomeIcon icon={faTachometerAlt} className=" w-12 h-12 hover:text-blue-500"/>account
             </Link>
             <Link to="logout">
               <FontAwesomeIcon icon={faSignOut} className=" w-12 h-12 hover:text-blue-500"/>logout
             </Link>            
            </div>
            <div className=" flex flex-col ">
              {customerData?.profile?.length>0?<img src={customerData?.profile} className=" w-20 h-20 rounded-full"
              />:
              <div className=" h-12 w-12 rounded-full">
                <FontAwesomeIcon icon={faUser}/>
              </div>
              }
               <p>Username :{customerData?.username}</p>
               <p>Useremail :{customerData?.email}</p>
               <p>name :{customerData?.name}</p>
              </div>
              
             <Outlet/>
                
        </div>
    )

}